import { combineEpics, ofType } from 'redux-observable';
import { Observable, of } from 'rxjs';
import { catchError, groupBy, map, mergeMap, startWith, throttleTime } from 'rxjs/operators';
import { requestActions } from '../apiHelpers';
import { ID, ReduxAction, UserSession } from '../../types';
import { apiObservable } from '@support/api';

/* Epic actions */
const sharedContactMomentsActions = requestActions('SHARED_CONTACT_MOMENTS', ['fetch']);

/* Component actions */
export const fetchSharedContactMoments = (contactUUID: ID, user: UserSession | null) =>
  sharedContactMomentsActions['fetch']({ contactUUID, authenticatedUser: !!user });

/* Epics */
const fetchSharedContactMomentsEpic = (action$: Observable<ReduxAction>) =>
  action$.pipe(
    ofType('FETCH_SHARED_CONTACT_MOMENTS'),
    groupBy(({ payload }) => payload.contactUUID),
    mergeMap((fetchesByUUID) =>
      fetchesByUUID.pipe(
        throttleTime(1000 * 60 * 1),
        mergeMap(({ payload }) =>
          apiObservable(
            'GET',
            `/network/shared-contacts/${payload.contactUUID}/interactions/summary/`,
            undefined,
            {
              noAuthorization: !payload.authenticatedUser,
            },
          ).pipe(
            map(({ response }) =>
              sharedContactMomentsActions['fetchSucceeded']({
                response,
                contactUUID: payload.contactUUID,
              }),
            ),
            startWith(
              sharedContactMomentsActions['fetchRequested']({ contactUUID: payload.contactUUID }),
            ),
            catchError((err) =>
              of(
                sharedContactMomentsActions['fetchFailed']({
                  ...err,
                  contactUUID: payload.contactUUID,
                }),
              ),
            ),
          ),
        ),
      ),
    ),
  );

export const sharedMomentsEpic = combineEpics(fetchSharedContactMomentsEpic);
